import React, { useRef } from "react"
import Lottie from "lottie-web"

const LottieControl = React.forwardRef(
  ({ animationData, config = {}, onInit, ...props }, ref) => {
    const isInited = useRef(null)
    return (
      <div
        ref={(dom) => {
          if (dom && !isInited.current) {
            isInited.current = Lottie.loadAnimation({
              container: dom, // the dom element that will contain the animation
              renderer: "svg",
              rendererSettings: {
                ...config.rendererSettings,
              },
              loop: true,
              autoplay: true,
              ...config,
              animationData,
            })
            if (ref) {
              ref.current = isInited.current
            }
            onInit?.()
          }
        }}
        {...props}
      />
    )
  }
)

export default LottieControl
